module.exports = __webpack_public_path__ + "img/korean-child.c03dfe7a.png";